var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTailHorizontal = function SvgTailHorizontal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "53.346px",
    height: "27.379px",
    viewBox: "0 0 53.346 27.379",
    enableBackground: "new 0 0 53.346 27.379",
    xmlSpace: "preserve"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    stroke: "#e9e9e8",
    fill: "currentColor",
    d: "M3.143-0.001c-3.765,16.96-3.097,27.38-3.097,27.38s13.333-27.335,53.3-27.335"
  }))));
};
export default SvgTailHorizontal;